/*eslint-disable */
import _ from 'lodash'


export function getAllMessagesForDashboard (state, getters, rootState, rootGetters) {
  const currentUserId = Number(rootGetters['currentUser/getId'])
  const messages = _.filter(state.items,(message) =>
    Number(message.senderId) !== currentUserId
  )
  return _.orderBy(messages, ['createdAt'], ['asc'])
}

export function getAllMessages (state) {
  return _.orderBy(state.items, ['id'], ['asc'])
}

export function getAllInternalRfqMessage (state) {
  let messages = _.filter(state.items, (itm) => {
    return itm.type === 'InternalRfqMsg'
  })
  return _.orderBy(messages, ['id'], ['asc'])
}

export function getAllOrderMessage (state) {
  let messages = _.filter(state.items, (itm) => {
    return itm.type === 'OrderMsg'
  })
  return _.orderBy(messages, ['id'], ['asc'])
}

/**
 * Get users list for mentions with special groups
 * @param {Object} state - Module state
 * @param {Object} getters - Module getters
 * @param {Object} rootState - Root state
 * @param {Object} rootGetters - Root getters
 * @returns {Array} - Sorted array of users with groups
 */
export function getMentionUsers (state, getters, rootState, rootGetters) {
  const groups = [
    { gid: -1, name: 'All - Users' },
    { gid: 3, name: 'All - Part Coordinators' },
    { gid: 2, name: 'All - Estimators' }
  ]

  let users = []
  const allUsers = rootGetters['users/getAllUsers'] || []
  const userId = rootGetters['currentUser/getId']
  if (rootGetters['currentUser/isAdministrator'] || rootGetters['currentUser/isPartsCoordinator']) {
    // Administrators and Parts Coordinators see all users
    users = _(allUsers)
      .filter(user => user.id !== userId)
      .map(user => ({
        uid: user.id,
        name: `${user.firstName} ${user.lastName}`.trim()
      }))
      .orderBy(['name'], ['asc'])
      .value()
  } else if (rootGetters['currentUser/isEstimator']) {
    // Estimators only see users from groups 1 and 2
    users = _(allUsers)
      .filter(user => user.id !== userId && (Number(user.groupId) === 1 || Number(user.groupId) === 3))
      .map(user => ({
        uid: user.id,
        name: `${user.firstName} ${user.lastName}`.trim()
      }))
      .orderBy(['name'], ['asc'])
      .value()
  }

  return [...groups, ...users]
}
